import React from 'react'
import Tooltip from '@mui/material/Tooltip'

interface UsageCellProps {
  value: string
  tooltip: string
}

const UsageCell = ({ value, tooltip }: UsageCellProps) => (
  <Tooltip title={tooltip} placement='top' arrow>
    <span className="fw-bold">{value}</span>
  </Tooltip>
)

export default UsageCell
